import enLocale from 'vant/es/locale/lang/en-US';

export const lang = {
  vant: enLocale,
  tjcg: 'Envío exitoso',
  gmcg: 'Compra realizada',
  ts: 'Aviso',
  qrz: 'Ir a verificar',
  qx: 'Cancelar',
  qxzwj: 'Seleccione un archivo',
  yjs: 'Finalizado',
  fl: 'Cat.',
  bkzh: 'No canjeable',
  yrz: 'Verificado',
  kzh: 'Canjeable',
  cpjs: 'Descripción del producto',
  xzrq: 'Seleccionar fecha',
  qd: 'Confirmar',
  qxz: 'Por favor seleccione',
  xlsx: 'Deslizar para refrescar',
  zzsx: 'Actualizando',
  'zzsx...': 'Actualizando...',
  zzjz: 'Cargando',
  'zzjz...': 'Cargando...',
  ddl: 'No hay más',
  jzgd: 'Cargar más',
  mygdl: 'No hay más contenido',
  sxcg: 'Actualización exitosa',
  sxsb: 'Error al actualizar',
  gdz: 'Desplazándose',
  ycd: 'Has llegado al final',
  xz: 'Seleccionar',
  zdxz: 'Máximo seleccionable',
  x: 'elementos',
  qsr: 'Por favor ingrese',
  qzqtx: 'Complete correctamente',
  sj: 'Datos',
  cxcxz: 'Elegir desde álbum',
  pz: 'Tomar foto',
  xzsp: 'Seleccionar video',
  qxzszdq: 'Seleccione su región',
  qscsphtp: 'Suba un video o imagen',
  wjdxbncg: 'El archivo no puede superar',
  zzdkxj: 'Abriendo cámara',
  pzcg: 'Foto tomada',
  pzsb: 'Error al tomar foto',
  pzgccc: 'Error durante la captura',
  myxjqx: 'Sin permiso de cámara',
  xyqx: 'Permiso requerido',
  qyxyyfwxjyjxpz:
    'Permita que la aplicación acceda a la cámara para tomar fotos',
  zbjx: 'Listo',
  myzdxc: 'No se encontró ningún álbum',
  qxcjygxc: 'Cree un álbum primero',
  tpybcdxc: 'La imagen se guardó en el álbum',
  bcsb: 'Error al guardar',
  djck: 'Toca para ver',
  tj: 'Añadir',
  tbz: 'Sincronizando',
  tbsb: 'Error de sincronización',
  ljz: 'Conectando',
  ljsb: 'Conexión fallida',
  ssz: 'Buscando',
  jzz: 'Cargando',
  xx: 'Mensajes',
  txl: 'Contactos',
  gzt: 'Panel',
  wd: 'Mi perfil',
  hysy: 'Bienvenido',
  ssjgwk: 'Sin resultados',
  nyytxxx: 'Tienes un nuevo mensaje',
  lx: 'Desconectado',
  zx: 'En línea',
  gly: 'Administrador',
  qz: 'Propietario del grupo',
  ql: 'Chat grupal',
  qnc: 'Nombre en el grupo',
  jrsj: 'Fecha de ingreso',
  rqfs: 'Método de ingreso',
  swgly: 'Establecer como administrador',
  szjy: 'Silenciar',
  grzl: 'Perfil',
  yqjq: 'Invitar al grupo',
  smjq: 'Escanear para unirse',
  ssjq: 'Buscar para unirse',
  cy: 'Miembros',
  qcy: 'Miembros del grupo',
  gd: 'Más',
  qlyz: 'Verificación de ingreso',
  qcyqx: 'Permisos de miembros',
  zrqz: 'Transferir propiedad',
  byxckqtqcyzl: 'No se permite ver perfiles de otros miembros',
  byxtjqcywhy: 'No se permite añadir miembros como amigos',
  qxjy: 'Quitar silencio',
  zdy: 'Personalizado',
  wb: 'Texto',
  tp: 'Imagen',
  sp: 'Video',
  wj: 'Archivo',
  mp: 'Mis cuentas',
  xxyx: 'Mensajes seleccionados',
  xxjsrlb: 'Lista de destinatarios',
  qbyd: 'Todo leído',
  yd: 'Leído',
  wd_1: 'No leído',
  rwd: 'Personas sin leer',
  cjql: 'Crear chat grupal',
  qmsy: 'Uso completo',
  jrql: 'Unirse al grupo',
  xglyhtdcyxw: 'Consultar al administrador o miembros del equipo',
  ljcj: 'Crear ahora',
  sqjr: 'Solicitar unirse',
  n: 'Tú',
  sqtj: 'Solicitar agregar',
  why: 'como amigo',
  yzxx: 'Información de verificación',
  sqly: 'Motivo de solicitud',
  xzndtx: 'Selecciona tu foto de perfil',
  wjmm: 'Olvidé la contraseña',
  mm: 'Contraseña',
  qrmm: 'Confirmar contraseña',
  qzcqrndmm: 'Confirme su contraseña nuevamente',
  h: 'y',
  yyzh: 'Ya tengo cuenta',
  hmyzh: 'Aún no tengo cuenta',
  ljzc: 'Registrarse ahora',
  sjh: 'Número de móvil',
  w: 'dígitos',
  zsbhsz: 'Debe contener números',
  zm: 'letras',
  yzsjh: 'Verificar número de móvil',
  qsrfsd: 'Introduzca el enviado a',
  d: 'de',
  wyzm: 'código de verificación de dígitos',
  yxq: 'Validez',
  fz: 'minutos',
  zf: 'Reenviar',
  yzm: 'Código de verificación',
  m: 'segundos',
  zwsj: 'Sin datos',
  ewm: 'Código QR',
  smewm: 'Escanear código QR',
  smewmmp: 'Escanear tarjeta QR',
  qewm: 'Código QR del grupo',
  yh: 'Usuario',
  xb: 'Género',
  nc: 'Nombre',
  yhnc: 'Nombre de usuario',
  bz: 'Nota',
  xgnc: 'Modificar nombre',
  nl: 'Edad',
  sr: 'Fecha de nacimiento',
  yx: 'Correo electrónico',
  s: 'años',
  bm: 'Privado',
  n_1: 'Mujer',
  n_2: 'Hombre',
  kq: 'Activar',
  gb: 'Desactivar',
  zh: 'General',
  ltjl: 'Historial de chat',
  tjhy: 'Añadir amigo',
  dfyszbyxbtjwhy: 'El usuario no permite ser añadido como amigo',
  tgs: 'Manualmente',
  sstj: 'Añadir mediante búsqueda',
  tjqz: 'Añadir grupo',
  ss: 'Buscar',
  sphy: 'Videoconferencia',
  txgjl: 'registros relacionados',
  r: 'personas',
  hyyz: 'Verificación de amigo',
  fxx: 'Enviar mensaje',
  qmc: 'Nombre del grupo',
  tx: 'Foto de perfil',
  qtx: 'Perfil del grupo',
  djsc: 'Haga clic para subir',
  yq: 'Invitar',
  lxryx: 'Contactos seleccionados',
  tjqcy: 'Añadir miembros',
  ycqcy: 'Eliminar miembros',
  cj: 'Crear',
  sddqq: 'Solicitudes recibidas',
  fcdqq: 'Solicitudes enviadas',
  yxrhrjq: 'Permitir que cualquiera se una',
  xyfsyzxx: 'Requiere mensaje de verificación',
  qcyyq: 'Invitación de miembros',
  qcyyqwxyz: 'Invitación sin verificación',
  tjql: 'Añadir chat grupal',
  cjptq: 'Crear grupo normal',
  cjgzq: 'Crear grupo de trabajo',
  grxx: 'Información personal',
  zfxx: 'Reenviar mensaje',
  jdltjl: 'Historial entre chats',
  zdltjl: 'Historial dentro del chat',
  zzsr: 'Escribiendo…',
  scz: 'Subiendo',
  zw: 'Ninguno',
  t: 'elementos',
  sjzx: 'Móvil en línea',
  sys: 'Escanear',
  fqql: 'Iniciar chat grupal',
  lz: 'Grabar',
  ssq: 'Buscar grupo',
  ly: 'Origen',
  dr: 'personas',
  cz: 'Buscar',
  hysz: 'Configuración de amigos',
  szbz: 'Establecer nota',
  bttjgpy: 'Recomendarlo a amigos',
  jchygx: 'Eliminar amistad',
  xgqlmc: 'Modificar nombre del grupo',
  wzqldnc: 'Mi nombre en este grupo',
  txxx: 'nuevos mensajes',
  hbzf: 'Reenviar combinado',
  dltjl: 'historial de chat',
  syr: 'Todos',
  txgltjl: 'registros de chat relacionados',
  wdwz: 'Mi ubicación',
  ckgdxglxr: 'Ver más contactos relacionados',
  ckgdxgqz: 'Ver más grupos relacionados',
  ckgdxgltjl: 'Ver más chats relacionados',
  ckgdxgwd: 'Ver más documentos relacionados',
  zyqzjglykbj: 'Solo el propietario y administradores pueden editar',
  qgl: 'Gestión del grupo',
  qyjy: 'Silenciar a todos',
  jqyz: 'Verificación de ingreso',
  qzglqzr: 'Transferir propiedad del grupo',
  qlsz: 'Configuración del grupo',
  wzbqdnc: 'Mi apodo en este grupo',
  zdql: 'Fijar chat grupal',
  ckqbqcy: 'Ver todos los miembros',
  xttz: 'Notificación del sistema',
  ksczltjl: 'Buscar chats rápidamente',
  myzd: 'No encontrado',
  xgnr: 'Contenido relacionado',
  ltsz: 'Configuración del chat',
  zdlxr: 'Fijar contacto',
  yhjf: 'Autodestrucción tras leer',
  sjsz: 'Configuración de tiempo',
  zczhfsdxx: 'Mensajes enviados después de esto',
  hyydhhzxzdsjzhzdsc:
    'Se eliminará automáticamente tras ser leído según el tiempo elegido',
  yhzc: 'Registro de usuario',
  yqm: 'Código de invitación',
  xt: 'Opcional',
  szxx: 'Configurar información',
  xgmm: 'Cambiar contraseña',
  jmm: 'Contraseña antigua',
  xmm: 'Nueva contraseña',
  yxz: 'Seleccionado',
  gbsgd: 'Apagar flash',
  kqsgd: 'Encender flash',
  dfyblrhmd: 'El usuario está en la lista negra',
  nybzgqz: 'Ya no estás en este grupo',
  qzhglyykqqtjy: 'El propietario o admin activó silencio global',
  gqzybjs: 'El grupo ha sido disuelto',
  gqzybfj: 'El grupo ha sido bloqueado',
  nybjy: 'Has sido silenciado',
  qsrnc: 'Introduzca nombre',
  qsryqm: 'Introduzca código de invitación',
  qsryzm: 'Introduzca código de verificación',
  qsrqgg: 'Introduzca anuncio del grupo',
  qsrmm: 'Introduzca contraseña',
  qqrsrmm: 'Confirme la contraseña',
  qsrsjh: 'Introduzca número móvil',
  srxx: 'Introducir información',
  qsrqmc: 'Introduzca nombre del grupo',
  zzlsrxx: 'Escribe un mensaje aquí',
  qsrndnc: 'Introduzca su nombre',
  wccj: 'Creación completada',
  qsryx: 'Introduzca correo electrónico',
  ty: 'Aceptar',
  jj: 'Rechazar',
  qr: 'Confirmar',
  qclsxx: 'Borrar historial',
  jsql: 'Disolver grupo',
  tcql: 'Salir del grupo',
  bc: 'Guardar',
  fb: 'Publicar',
  bj: 'Editar',
  qc: 'Limpiar',
  jchy: 'Eliminar amigo',
  ddyz: 'Esperando verificación',
  yjj: 'Rechazado',
  yty: 'Aprobado',
  fsyzm: 'Enviar código',
  dl: 'Iniciar sesión',
  yzmdl: 'Login con código',
  mmdl: 'Login con contraseña',
  sjhdl: 'Login con móvil',
  yxdl: 'Login con correo',
  sjhzc: 'Registro con móvil',
  yxzc: 'Registro con correo',
  sjhzhmm: 'Recuperar contraseña por móvil',
  yxzhmm: 'Recuperar contraseña por correo',
  zc: 'Registrarse',
  xg: 'Modificar',
  jr: 'Entrar',
  xyb: 'Siguiente',
  yc: 'Eliminar',
  fssq: 'Enviar solicitud',
  zd: 'Fijar',
  qxzd: 'Quitar fijado',
  bjyd: 'Marcar como leído',
  fs: 'Enviar',
  ck: 'Ver',
  azsh: 'Mantén pulsado para hablar',
  skfs: 'Soltar para enviar',
  skqx: 'Soltar para cancelar',
  yyxx: 'Mensaje de voz',
  wjxx: 'Mensaje de archivo',
  tpxx: 'Mensaje de imagen',
  spxx: 'Mensaje de video',
  mpxx: 'Información de cuenta',
  szgly: 'Establecer administrador',
  qgg: 'Anuncio del grupo',
  sz: 'Configuración',
  nqdytcgcym: '¿Seguro que deseas expulsar a este miembro?',
  qkltjl: 'Borrar historial de chat',
  sch: 'Después de eliminar',
  jwfckchhdxx: 'No podrás ver la información de esta conversación',
  qrqkltjlm: '¿Confirmar borrar historial?',
  xxmdr: 'Silenciar notificaciones',
  pbxx: 'Bloquear mensajes',
  qtjy: 'Silenciar a todos',
  jrhmd: 'Añadir a lista negra',
  zf_1: 'Reenviar',
  fz_1: 'Copiar',
  ch: 'Retirar',
  dx: 'Selección múltiple',
  hf: 'Responder',
  sc: 'Eliminar',
  lxr: 'Persona de contacto',
  cylxr: 'Contactos frecuentes',
  xdhy: 'Nuevos amigos',
  xdql: 'Nuevos grupos',
  wdhy: 'Mis amigos',
  wdqz: 'Mis grupos',
  sqrq: 'Solicitar unirse al grupo',
  wdsq: 'Mis solicitudes',
  ahyx: 'Seleccionar por amigos',
  aqlx: 'Seleccionar por grupos',
  ajgx: 'Seleccionar por estructura',
  zjhh: 'Conversaciones recientes',
  wcjd: 'Creados por mí',
  wjrd: 'A los que me uní',
  wdxx: 'Mi información',
  hmd: 'Lista negra',
  yy: 'Idioma',
  qcltjl: 'Borrar historial',
  zhsz: 'Configuración de cuenta',
  gywm: 'Sobre nosotros',
  tcdl: 'Cerrar sesión',
  sctsrz: 'Subir registro de depuración',
  txlhmd: 'Lista negra de contactos',
  wrms: 'Modo no molestar',
  xxxtsy: 'Tono de notificación',
  jztjwwhy: 'No permitir agregarme como amigo',
  wzxx: 'Mensaje de ubicación',
  hbxx: 'Combinar mensajes',
  zdyxx: 'Mensaje personalizado',
  yyxx_1: 'Mensaje citado',
  bqxx: 'Mensaje de emoji',
  cg: 'Borrador',
  yr: 'Alguien',
  zbzcdxxlx: 'Tipo de mensaje no compatible',
  tzxx: 'Mensaje de notificación',
  hyxx: 'Mensaje de reunión',
  yynrybch: 'El contenido citado fue retirado',
  yy_1: 'Voz',
  wz: 'Ubicación',
  bq: 'Emoji',
  th: 'Llamada',
  d_1: 'etc.',
  chlytxx: 'Retiró un mensaje',
  chlyt: 'Retiró uno',
  fsdxx: 'mensaje enviado',
  nmyjshyl: 'Ya son amigos',
  ksltb: 'Empieza a chatear',
  cjlql: 'Creó un grupo',
  xglqxx: 'Modificó la información del grupo',
  xglqmcw: 'Cambió el nombre del grupo a',
  xglqgg: 'Modificó el anuncio del grupo',
  zrlqzg: 'Transferió la propiedad a',
  tclql: 'Salió del grupo',
  yql: 'Invitó a',
  tcl: 'Expulsó a',
  jrlql: 'Se unió al grupo',
  jslql: 'Disolvió el grupo',
  kqlqtjy: 'Activó silencio global',
  gblqtjy: 'Desactivó silencio global',
  b: 'fue',
  jyl: 'silenciado',
  qxljy: 'Quitó el silencio',
  yhjfy: 'Mensaje efímero activado',
  hqzxztsb: 'Error al obtener estado en línea',
  hqqcysb: 'Error al obtener miembros',
  ssxxsb: 'Error al buscar mensajes',
  hqyhxxsb: 'Error al obtener información del usuario',
  fsyzmsb: 'Error al enviar código',
  gzhybzc: 'Esta cuenta ya está registrada',
  zhwzc: 'Cuenta no registrada',
  mmcw: 'Contraseña incorrecta',
  lcsrdmmbyz: 'Las contraseñas no coinciden',
  hq: 'Obtener',
  sb: 'Falló',
  yzmcwhygq: 'Código incorrecto o expirado',
  zcsb: 'Registro fallido',
  dlsb: 'Inicio de sesión fallido',
  yzsb: 'Verificación fallida',
  xggrxxsb: 'Error al modificar información personal',
  czcg: 'Operación exitosa',
  czsb: 'Operación fallida',
  fzcg: 'Copiado correctamente',
  fzsb: 'Error al copiar',
  sssb: 'Búsqueda fallida',
  fsqqcg: 'Solicitud enviada correctamente',
  fsqqsb: 'Error al enviar solicitud',
  hqhhxxsb: 'Error al obtener información de conversación',
  bfxxscsb: 'Error al eliminar algunos mensajes',
  nrbnwk: 'El contenido no puede estar vacío',
  cjcg: 'Creado correctamente',
  scsb: 'Error al subir',
  sysqewm: 'Escanear QR del grupo',
  lkjrgq: 'Unirse al grupo ahora',
  sysxmdewm: 'Escanear el código QR abajo',
  tjwwhy: 'Añádeme como amigo',
  dqdlygq: 'Sesión expirada',
  qcxdl: 'Inicie sesión nuevamente',
  ndzhyzqtsbdl: 'Cuenta iniciada en otro dispositivo',
  qdyfs: 'Confirmar envío',
  dmpm: '¿Enviar esta tarjeta?',
  fscg: 'Enviado correctamente',
  fssb: 'Error al enviar',
  yqcg: 'Invitación enviada',
  yqsb: 'Error al invitar',
  qrjqzzg: 'Confirmar transferir propiedad a',
  yccg: 'Eliminado correctamente',
  wsbdyxnr: 'No se detectó contenido válido',
  nyjrgq: 'Ya te uniste al grupo',
  qrjchygx: 'Confirmar eliminar amistad',
  xgcg: 'Modificado correctamente',
  xgsb: 'Error al modificar',
  sccg: 'Eliminado correctamente',
  hqqxsbhdqllqbzc: 'Error de permisos o navegador no compatible',
  hqdw: 'Obtener ubicación',
  hqdwsb: 'Error al obtener ubicación',
  yqx: 'Cancelado',
  lzsjtdl: 'Grabación demasiado corta',
  scfmtsb: 'Error al generar portada',
  jzsb: 'Error al cargar',
  jsqlh: 'Tras disolver el grupo',
  syqcyjsqhqydlx: 'Todos los miembros perderán el contacto',
  tcqlh: 'Después de salir del grupo',
  qsrzqdsjh: 'Introduzca un número válido',
  qsrzqdyx: 'Introduzca un correo válido',
  mmgsbzq: 'Formato de contraseña incorrecto',
  lcmmbyz: 'Las contraseñas no coinciden',
  xgmmcg: 'Contraseña modificada correctamente',
  qdytcdlm: '¿Seguro que desea cerrar sesión?',
  qsrzqdyxzh: 'Introduzca un correo correcto',
  xs: 'horas',
  t_1: 'días',
  gg: 'justo ahora',
  bz_1: 'esta semana',
  by: 'este mes',
  gz: 'antes',
  xc: 'Álbum',
  ps: 'Capturar',
  spth: 'Videollamada',
  jtzw: 'Chino simplificado',
  yw: 'Inglés',
  zhbcz: 'Cuenta inexistente',
  sjhyzc: 'Número ya registrado',
  zhyzc: 'Cuenta ya registrada',
  czgypf: 'Operación demasiado frecuente',
  qshzs: 'Inténtelo más tarde',
  yzmcw: 'Código incorrecto',
  yzmygq: 'Código expirado',
  yzmcwcscgxz: 'Demasiados intentos incorrectos',
  yzmybsy: 'Código ya usado',
  yqmybsy: 'Código de invitación usado',
  yqmbcz: 'Código de invitación inexistente',
  czxz: 'Operación restringida',
  yyth: 'Llamada de voz',
  cswjt: 'No contestado por tiempo',
  thsc: 'Duración de llamada',
  yzqtsbcl: 'Gestionado en otro dispositivo',
  jrsb: 'Error al unirse',
  fqyqsb: 'Error al iniciar invitación',
  mkfyk: 'Micrófono activado',
  mkfyg: 'Micrófono desactivado',
  jt: 'Responder',
  gd_1: 'Colgar',
  ysqyk: 'Altavoz activado',
  ysqyg: 'Altavoz desactivado',
  ddjt: 'Esperando conexión',
  thz: 'En llamada',
  yqnyyth: 'Te invita a llamada de voz',
  yqnspth: 'Te invita a videollamada',
  zzhjz: 'Llamando',
  jrth: 'Unirse a llamada',
  thjl: 'Historial de llamadas',
  syth: 'Todas las llamadas',
  wjth: 'Llamadas perdidas',
  hr: 'Entrante',
  hc: 'Saliente',
  zc_1: 'TOP',
  td: 'Visita',
  dh: 'Promocional',
  tg: 'Colab.',
  zhcgt: 'Recomendación',
  tdgt: 'Visita a tienda',
  ddgt: 'Promocional',
  jcqxsb: 'Error al verificar permisos',
  qqqxsb: 'Solicitud de permisos fallida',
  jrgxjc: 'Comprobando actualizaciones',
  xbbxx: 'Información de nueva versión',
  xbb: 'Nueva versión',
  jbb: 'Versión antigua',
  yyxzjxz: 'Descarga en curso',
  hlbccf: 'Ignorar esta vez',
  xzwc: 'Descarga completada',
  yzbhgx: 'Actualización lista',
  xzsb: 'Descarga fallida',
  bbyz: 'Versión idéntica',
  wxgx: 'No necesita actualización',
  jcbbcc: 'Error al comprobar versión',
  dy: 'Invocar',
  apgx: 'Programar actualización',
  yygx: 'Actualizar aplicación',
  jhgxsb: 'Error al activar actualización',
  wdtg: 'Mis anuncios',
  wdsc: 'Mis favoritos',
  wdmp: 'Mis cuentas',
  tjmp: 'Añadir cuenta',
  wddz: 'Mis direcciones',
  tjdz: 'Añadir dirección',
  tgq: 'Cupones',
  gzlb: 'Lista de seguimiento',
  gmjl: 'Historial de compras',
  gmtgq: 'Comprar cupones de campaña',
  zj: 'Historial',
  tgzzy: 'Página del anunciante',
  tgzrz: 'Verificación del anunciante',
  bm_1: 'Inscribir',
  xtxx: 'Mensajes del sistema',
  drgc: 'Creators',
  sh: 'Revisión',
  gzsc: 'Seguir y favoritos',
  tgbm: 'Solicitud de anuncio',
  xq: 'Detalles',
  tbsc: 'Tienda',
  dhxq: 'Detalles de canje',
  qb: 'Monedero',
  cz_1: 'Recargar',
  tx_1: 'Retirar',
  txmx: 'Detalles de retiro',
  mx: 'Detalles',
  wdyhk: 'Mis tarjetas bancarias',
  tjyhk: 'Añadir tarjeta bancaria',
  lx_1: 'Contactar',
  fbtg: 'Publicar campaña',
  tgxq: 'Detalles de campaña',
  sccg_1: 'Subir borrador',
  ptlj: 'Enlace de plataforma',
  jb: 'Reportar',
  bmlb: 'Lista de solicitudes',
  sxbz: 'Filtrar creadores',
  zdydq: 'Región personalizada',
  ssgg: 'Buscar anuncios',
  bmcg: 'Inscripción exitosa',
  tjbjlj: 'Enviar enlace de contenido',
  pj: 'Evaluar',
  ykyh: 'Usuario invitado',
  mt: 'Mañana',
  zt: 'Ayer',
  n_3: 'Año',
  y: 'Mes',
  r_1: 'Día',
  xhs: 'Xiaohongshu',
  dy_1: 'Douyin',
  jd: 'Entrar en',
  wlcw: 'Error de red',
  wlcwqshzs: 'Error de red. Inténtelo más tarde.',
  ndyebzqcz: 'Su saldo es insuficiente. Por favor recargue.',
  qshzs_1: 'Inténtelo más tarde',
  dlygq: 'Sesión expirada',
  yebz: 'Saldo insuficiente',
  ndyebz: 'Su saldo es insuficiente',
  qcz: 'Por favor recargue',
  qcz_1: 'Ir a recargar',
  xczs: 'Más tarde',
  qqsb: 'Solicitud fallida',
  bq_1: 'Etiqueta',
  bmdr: 'Personas inscritas',
  rbm: 'personas inscritas',
  ckbm: 'Ver solicitudes',
  lxfs: 'Información de contacto',
  bmhkj: 'Visible tras inscripción',
  kgdr: 'Personas que lo vieron',
  rll: 'visualizaciones',
  tgtj: 'Recomendaciones de campaña',
  ysc: 'Guardado',
  sc_1: 'Guardar',
  fx: 'Compartir',
  jzsj: 'Fecha límite',
  fsyq: 'Requisitos de seguidores',
  tgpp: 'Marca promocionada',
  zxsj: 'Tiempo de ejecución',
  hzxs: 'Tipo de colaboración',
  bzyq: 'Requisitos del creador',
  sysjkcy: 'Escanea para participar',
  bchb: 'Guardar póster',
  gbhb: 'Cerrar póster',
  schb: 'Generar póster',
  sclj: 'Generar enlace',
  bmcj: 'Participar',
  rsym: 'Cupo completo',
  meym: 'Cupo agotado',
  ybm: 'Inscrito',
  ygb: 'Cerrado',
  gnkfz: 'Función en desarrollo',
  dqhjbzcfz: 'Entorno no compatible con copia',
  wzdhbnr: 'No se encontró contenido del póster',
  zzschb: 'Generando póster',
  hbybcdwj: 'Póster guardado',
  hbyxz: 'Póster descargado',
  bchbsb: 'Error al guardar póster',
  qzs: 'Inténtelo nuevamente',
  qrgbtg: 'Confirmar cerrar campaña',
  gtgjbzbgszgc: 'La campaña dejará de mostrarse',
  tgfb: 'Publicación de campaña',
  qwfbzjf: 'No publique anuncios falsos',
  dfdxjtg: 'Anuncios falsos o intermediarios',
  jcxx: 'Información básica',
  gf: 'Honorarios',
  wgf: 'Sin honorarios',
  gd_2: 'Fijo',
  qj: 'Rango',
  qsrgfjztbs: 'Introduzca valor en monedas',
  qsrgfjztbzdz: 'Introduzca valor mínimo',
  qsrgfjztbzgz: 'Introduzca valor máximo',
  hzfl: 'Beneficios de colaboración',
  zp: 'Regalo',
  wzp: 'Sin regalo',
  yzp: 'Con regalo',
  zpms: 'Descripción del regalo',
  qsrzpms: 'Introduzca descripción',
  zptbjz: 'Valor del regalo en monedas',
  qsrzptbjz: 'Introduzca valor del regalo',
  yjsymb: 'Usar plantilla con un clic',
  bzlx: 'Tipo de creador',
  qxzbzlx: 'Seleccione el tipo de creador',
  tgwa: 'Texto',
  qxztgwa: 'Seleccione el texto',
  wyydbty: 'He leído y acepto',
  tgfwxy: 'Acuerdo de servicio',
  yl: 'Vista previa',
  bt: 'Título',
  qsrbhcpm: 'Introduzca nombre del producto',
  tdcsmdbt: 'Título con ciudad',
  pt: 'Plataforma',
  dhxs: 'Tipo de promoción',
  zbdh: 'Venta en directo',
  twgc: 'Post con enlace',
  spgc: 'Video con enlace',
  bx: 'Sin límite',
  sptbjz: 'Valor del producto',
  tgf: 'Tarifa de campaña',
  tb: 'Monedas',
  hzyjtbjz: 'Valor de comisión',
  yb: 'Código postal',
  szsf: 'Provincia',
  szcs: 'Ciudad',
  ppmc: 'Nombre de marca',
  xqme: 'Cupos requeridos',
  qsrzzs: 'Introduzca número entero positivo',
  twsp: 'Imagen y video',
  tw: 'Imagen',
  dphj: 'Colección individual',
  dp: 'Producto individual',
  hj: 'Colección',
  jzrq: 'Fecha límite de inscripción',
  qxzjzrq: 'Seleccione la fecha límite de inscripción',
  fbyy: 'Idioma de la publicación',
  qzxfbyy: 'Seleccione el idioma',
  yjhgbfdwk:
    'La comisión y la tarifa no pueden estar ambas vacías; indique al menos una',
  rwmjzrq: 'Plazo de la tarea',
  xzrwmjzrq: 'Seleccione plazo de la tarea',
  rwmjzbnzybmjzrq:
    'El plazo de la tarea no puede ser anterior a la fecha límite de inscripción',
  qsrcpjs: 'Introduzca descripción',
  sycj: 'Escenario de uso',
  bzdhsjyqd: 'Requisitos de rendimiento',
  xh: 'Cuidado personal',
  qc_1: 'Automóvil',
  sp_1: 'Alimentación',
  cd: 'Moda',
  yxdm: 'Juegos y anime',
  cw: 'Mascotas',
  mz: 'Belleza',
  kjsm: 'Tecnología',
  ys: 'Bienestar',
  ydcw: 'Deportes y lifestyle',
  qt: 'Otros',
  gxcg: 'Actualizado correctamente',
  ddhtsh: 'Esperando revisión',
  qzyckxx: 'Revise los mensajes',
  qsrzqdgf: 'Introduzca tarifa correcta',
  qsrzqdjgqj: 'Introduzca rango correcto',
  gfzdzyxygfzgz: 'El mínimo debe ser menor',
  qsrzqdzpjz: 'Introduzca valor correcto',
  zpjzbnxy: 'El valor no puede ser menor',
  whz: 'Sin colaboración',
  qsrssgjc: 'Buscar',
  jxz: 'En progreso',
  dsg: 'Pend. de revisión',
  dfb: 'Pend. de publicar',
  ywc: 'Completado',
  j: 'Antiguo',
  x_1: 'Nuevo',
  tgyx: 'Prioridad de campaña',
  lyl: 'Chatear',
  ddtgzty: 'Esperando la aprobación del anunciante',
  bzsj: 'Vista del creador',
  wbm: 'No inscrito',
  dsgds: 'Todos pendientes de revisión',
  wlx: 'Sin contactar',
  ylxdwqr: 'Contactado sin confirmar',
  yqrhz: 'Colaboración confirmada',
  yjjhz: 'Colaboración rechazada',
  an: 'Botón',
  yhzd: 'Colaborados',
  xccg: 'Subir borrador primero',
  ytjcghybhd: 'Borrador enviado o rechazado',
  xgcg_1: 'Editar borrador',
  ckbj: 'Ver contenido',
  yshtg: 'Aprobar',
  tjbj: 'Enviar contenido',
  yfk: 'Pagado',
  ypj: 'Evaluado',
  tgz: 'Anunciante',
  shz: 'En revisión',
  shybh: 'Revisión rechazada',
  ftgxx: 'Enviar mensaje de campaña',
  gbtg: 'Cerrar campaña',
  qbm: 'Ir a inscribirse',
  wgs: 'No aprobado',
  sytgq: 'Cupones restantes',
  zm_1: 'Reclutar',
  bz_2: 'Creador',
  qh: 'Cambiar',
  lz_1: 'De',
  fs_1: 'Seguidores',
  fy: 'Nota',
  tjgdmp: 'Añadir más cuentas',
  sjdz: 'Dirección de envío',
  qxzsjdz: 'Seleccione dirección',
  yhzh: 'Cuenta bancaria',
  qxzyhzh: 'Seleccione cuenta bancaria',
  cjbm: 'Inscripción avanzada',
  qxzyptyzdmp: 'Seleccione cuenta coincidente',
  fslbdbhsbm: 'Seguidores insuficientes para inscribirse',
  qsrbt: 'Introduzca título',
  qzzlsrzw: 'Escriba el contenido aquí',
  cgyl: 'Vista previa del borrador',
  bhcg: 'Rechazar borrador',
  shtg: 'Aprobar',
  fhxg: 'Volver a editar',
  qrsc: 'Confirmar subida',
  bh: 'Rechazar',
  bhyy: 'Motivo del rechazo',
  qsrbhyy: 'Introduzca motivo',
  ylcg: 'Previsualizar borrador',
  qtxbthzw: 'Complete título o contenido',
  sccg_2: 'Subido correctamente',
  cgysc: 'Borrador subido',
  qzstjzw: 'Añada al menos contenido',
  tphsp: 'Imagen o video',
  qsrzsydzw: 'Introduzca al menos un texto',
  qzsscyztphsp: 'Suba al menos una imagen o video',
  qzsscyztp: 'Suba al menos una imagen',
  qrtgggjm: '¿Confirmar aprobación?',
  tgcg: 'Aprobado correctamente',
  cgytg: 'Borrador aprobado',
  cgbh: 'Borrador rechazado',
  cgybh: 'Borrador ya rechazado',
  c: 'veces',
  pf: 'Puntuación',
  me: 'Cupos',
  ylwz: 'Posición reservada',
  zctgkyzzlzs: 'Campañas recomendadas aquí',
  tgbh: 'ID de campaña',
  nrxs: 'Formato de contenido',
  dq: 'Región',
  zpfl: 'Beneficios de regalo',
  zpjz: 'Valor del regalo',
  hzyj: 'Comisión',
  qbpt: 'Plataformas',
  fssl: 'Seguidores',
  qbfl: 'Categorías',
  zz: 'Restablecer',
  zwtg: 'Sin campañas',
  ys_1: 'Arriba',
  ysdbjlsk: 'Distancia al viewport',
  xdzt: 'Estado fijo superior',
  nha: 'Hola',
  fsyq_1: 'Enviar invitación',
  qlmc: 'Nombre del grupo',
  ls: 'Li Si',
  wsbz: 'Soy influencer',
  hdh: 'Si está bien',
  srxx_1: 'Introducir mensaje',
  jyz: 'Silenciado',
  sdsmb: 'Di algo',
  yfb: 'Publicado',
  yhs: 'Adecuado',
  ytjcg: 'Borrador enviado',
  yxgtj: 'Modificado y enviado',
  shytg: 'Review aprobado',
  ytjbj: 'Post enviado',
  bzypj: 'Creador evaluó',
  tgzwpj: 'Anunciante no evaluó',
  tgzypj: 'Anunciante evaluó',
  bzwpj: 'Creador no evaluó',
  nyfk: 'Ya pagó',
  qggpjb: 'Por favor evalúe',
  tglcxx: 'Mensaje de proceso',
  sggl: 'Revisar borrador',
  lglglllsgg: 'Draft aprobado',
  sg: 'Revisar el borrador',
  cgyjtgl: 'El borrador ya fue aprobado',
  wxcfsg: 'No es necesario revisar de nuevo',
  fk: 'Pago',
  nyjfgkl: 'Ya ha pagado',
  wxcffk: 'No es necesario pagar de nuevo',
  dqzfxxh: 'Este pago consumirá',
  tbzh: 'Equivalente en monedas',
  oy: 'Euro',
  sfjx: '¿Desea continuar?',
  fkcg: 'Pago exitoso',
  nyjpjgl: 'Ya ha evaluado',
  tgywc: 'La campaña se ha completado',
  wfpj: 'No se puede evaluar',
  tjcg_1: 'Entregar el borrador',
  wxcftjcg: 'No repetir envío',
  fbbj: 'Campaña finalizada',
  rwjzrqygwfbm:
    'La fecha límite de la tarea ha pasado; no es posible registrarse.',
  wxcftjbj: 'Draft subido',
  tgyjs: 'La campaña ha finalizado',
  ysccg: 'Borrador subido',
  yj: 'Comisión',
  jz: 'Valor',
  hs: 'Adecuado',
  bhs: 'No adecuado',
  wfl: 'Sin beneficios',
  dtjcg: 'Pendiente de enviar borrador',
  dtjbj: 'Pendiente enviar contenido',
  dfk: 'Pendiente de pago',
  sdxx: 'Mensaje recibido',
  xxnr: 'Contenido del mensaje',
  zxxxsj: 'Hora del último mensaje',
  zxxx: 'Último mensaje',
  qjcfw: 'Por favor verifique el servicio',
  ljcg: 'Conexión exitosa',
  fwljsb: 'Error de conexión al servicio',
  ljgb: 'Conexión cerrada',
  fscw: 'Ocurrió un error',
  llqjdxxx: 'El navegador recibió un nuevo mensaje',
  khdzdgb: 'El cliente cerró la conexión',
  llqfcxx: 'El navegador envió un mensaje',
  fwxycs: 'Tiempo de respuesta del servicio agotado',
  ljcw: 'Error de conexión',
  fsfs_1: 'Envío fallido',
  fsfs_timeout: 'Tiempo de envío agotado, inténtelo más tarde',
  fsfs_nosocket: 'Conexión no inicializada, envío fallido',
  fsfs_connect_timeout: 'Tiempo de conexión agotado, envío fallido',
  fsfs_connect_error: 'Error de conexión, envío fallido',
  fsfs_connect_closed: 'Conexión cerrada, envío fallido',
  fsfs_send_error: 'Error al enviar el mensaje, inténtelo más tarde',
  fsfs_disconnect: 'Conexión perdida, envío fallido',
  jt_1: 'Hoy',
  sz_1: 'La semana pasada',
  nh: 'Hola',
  ysmkybndm: '¿En qué puedo ayudarle?',
  qxx: 'Mensajes del grupo',
  xxls: 'Historial de mensajes',
  yxx: 'Mensaje original',
  q: 'Grupo',
  fm: 'Portada',
  wdsl: 'Número de no leídos',
  nmtjbchz: 'Envío anónimo de esta colaboración',
  hscpjks: 'Todo empieza con una valoración',
  tj_1: 'Enviar',
  shpj: 'Evaluar más tarde',
  qgcpfhpjnr: 'Proporcione puntuación y comentario',
  ytjpj: 'Evaluación enviada',
  ldk: 'Registrar asistencia',
  dksb: 'Check-in fallido',
  dkcg: 'Check-in exitoso',
  xlsxcs: 'Prueba de actualización',
  wsydxd: 'Tengo límites',
  dw: 'Tócame',
  wszcymfhdsj: 'Datos devueltos de recomendación',
  ndzsyqm: 'Su código de invitación exclusivo',
  fzyqm: 'Copiar código',
  jyjtfxhtjgpyss: 'Se recomienda compartir captura',
  bcewm: 'Guardar código QR',
  fzfxlj: 'Copiar enlace',
  msfx: 'Compartir ahora',
  ggdl: 'Iniciar sesión con Google',
  xm: 'Proyecto',
  nh_1: 'Hola',
  qxzndjs: 'Seleccione su rol',
  wstgz: 'Soy anunciante',
  yhyx: 'Correo del usuario',
  yzmyfs: 'Código enviado',
  qcs: 'Revise por favor',
  hqyzm: 'Obtener código',
  hcxhq: 'Volver a obtener después',
  qsrzqyx: 'Introduzca correo válido',
  ccl: 'Ocurrió un error',
  qsctx: 'Suba una foto de perfil',
  xby: 'España',
  gj: 'País',
  xzgj: 'Seleccionar país',
  zg: 'China',
  tgfwh: 'Cuenta de servicio',
  z: 'Me gusta',
  tj_2: 'Recomendar',
  ly_1: 'Comentario',
  rhhqxhslj: 'Cómo obtener enlace Xiaohongshu',
  rhhqdylj: 'Cómo obtener enlace Douyin',
  rhhq: 'Cómo obtener',
  lj: 'Enlace',
  dyb: 'Paso 1',
  deb: 'Paso 2',
  dsb: 'Paso 3',
  dsib: 'Paso 4',
  gz_1: 'Seguir',
  jrybmcs: 'Solicitudes hoy',
  yxqz: 'Válido hasta',
  qxf: 'Renovar',
  ndvipjrdqqjsxf: 'Su VIP vence hoy. Renuévelo a tiempo.',
  ckviptc: 'Ver planes VIP',
  jrtclj: 'Entrar al paquete',
  kthyk: 'Activar membresía',
  tyvip: 'VIP de prueba',
  tygjtq: 'Probar premium',
  kt: 'Activar',
  tbye: 'Saldo de monedas',
  djstb: 'Monedas pendientes',
  ljjstb: 'Monedas acumuladas',
  dhsc: 'Tienda de canje',
  wdqb: 'Mi billetera',
  yhk: 'Tarjeta bancaria',
  dz: 'Dirección',
  qb_1: 'Todo',
  kbm: 'Disponible para aplicar',
  afbsj: 'Por fecha de publicación',
  ygq: 'Expirado',
  qxgz: 'Dejar de seguir',
  zwgz: 'Sin seguimientos',
  sfqxgzgtgz: '¿Dejar de seguir?',
  bzgz: 'Dejar de seguir',
  jxgz: 'Seguir',
  wdzj: 'Mi historial',
  qy: 'Beneficios',
  tz: 'Notificaciones',
  wdzy: 'Mi perfil',
  tgzkk: 'Activar tarjeta anunciante',
  hqtgzk: 'Obtener tarjeta',
  qkk: 'Activar',
  zdwdtg: 'Fijar mi campaña',
  ppf: 'Marca',
  dyygs: 'Agencia operadora',
  gr: 'Individual',
  ds: 'Comercio electrónico',
  rzz: 'Verificando',
  rzsb: 'Verificación fallida',
  wrztgz: 'Propietario no verificado',
  qxzgj: 'Seleccione país',
  sjr: 'Destinatario',
  qsryb: 'Introduzca código postal',
  xxdz: 'Dirección detallada',
  cs: 'Ciudad',
  xzcs: 'Seleccionar ciudad',
  swmr: 'Establecer por defecto',
  bjdz: 'Editar dirección',
  zxq: 'Municipio',
  mr: 'Predeterminado',
  nhmytjdz: 'No ha añadido dirección',
  qtj: 'Añadir ahora',
  mpxx_1: 'Información de tarjeta',
  qxzpt: 'Seleccione plataforma',
  mppt: 'Plataforma de cuenta',
  djqhpt: 'Cambiar plataforma',
  qtx_1: 'Por favor complete',
  xts: 'Consejo',
  dyfzdljxysdqmwzbf: 'Elimine texto previo del enlace',
  ljznl: '¿Dónde está el enlace',
  hzbj: 'Oferta de colaboración',
  sdzbj: 'Precio propio',
  hzfs: 'Método de cooperación',
  txhzfs: 'Complete método',
  khzdrly: 'Áreas de colaboración',
  lybq: 'Etiquetas de área',
  qxzlybq: 'Seleccione etiquetas',
  zd_1: 'Máximo',
  g: 'unidades',
  zhjt: 'Captura de cuenta',
  qsczhjt: 'Suba captura',
  scd: 'Subido',
  ymjtbxsdqmpdydzh: 'Debe coincidir con la cuenta',
  qwbscnbrdzh: 'Suba su propia cuenta',
  qqbjtqxwzl: 'Asegure captura clara',
  xxwz: 'Información completa',
  bhtx: 'Incluye perfil',
  fss: 'Número de seguidores',
  dzsdgjxx: 'Likes y datos clave',
  tjrz: 'Enviar verificación',
  gly_1: 'campos',
  mpxq: 'Detalles de cuenta',
  gxsj: 'Hora de actualización',
  sdgx: 'Actualización manual',
  zy: 'Página principal',
  dz_1: 'Me gusta',
  kdzbj: 'Precio personalizado',
  sxly: 'Campos seleccionados',
  ptpphzrdxtwb: 'Texto opcional',
  yjzs: 'Mostrar si existe',
  mxjbzs: 'No mostrar si vacío',
  swbmmr: 'Establecer por defecto',
  bjmp: 'Editar cuenta',
  sjzbj: 'Precio comerciante',
  ptpphzrd: 'Colaboradores de marca',
  scmp: 'Eliminar cuenta',
  qsrlybq: 'Introduzca etiquetas',
  qryscbq: 'Confirmar eliminar etiqueta',
  mplb: 'Lista de cuentas',
  nhmytjmp: 'No has añadido cuenta',
  rzytg: 'Verificación aprobada',
  rzybh: 'Verificación rechazada',
  wrz: 'No verificado',
  dsh: 'Pendiente revisión',
  qxzshtgdmp: 'Seleccione cuenta aprobada',
  cxsh: 'Reenviar para revisión',
  fhyzdznylzmp: 'Máx. dos cuentas sin membresía',
  sfyqmhy: '¿Comprar membresía?',
  qmhyy: 'Ir a membresía',
  xzpt: 'Seleccionar plataforma',
  tbggtx: 'Sincronizar perfil Google',
  tbcg: 'Sincronización exitosa',
  ytbggtx: 'Perfil sincronizado',
  gh: 'Cambiar',
  xrsc: 'Guía para nuevos usuarios',
  lxkf: 'Contactar soporte',
  tkgz: 'Términos y reglas',
  wx: 'WeChat',
  nhsy: 'Le quedan',
  ztgq: 'cupones',
  z_1: 'unidades',
  lkgm: 'Comprar ahora',
  tgqgmxy: 'Acuerdo de compra',
  q_1: 'cupón',
  qhq: 'Obtener',
  lx_2: 'Tipo',
  zwgmjl: 'Sin historial de compra',
  tgqgmjl: 'Historial de cupones',
  ygm: 'Comprado',
  shwtg: 'Revisión no aprobada',
  ytg: 'Aprobado',
  tbjs: 'Liquidación de monedas',
  nsqd: 'Su solicitud',
  jszzshz: 'Liquidación en revisión',
  qnxdd: 'Espere por favor',
  yjjswc: 'Cálculo completado',
  zwxx: 'Sin mensajes',
  shsj: 'Tiempo de revisión',
  hd: 'De acuerdo',
  hg: 'Seguir de vuelta',
  zwxxx: 'No hay mensajes nuevos',
  drgcxx: 'Mensajes del centro de creadores',
  h_1: 'Nº',
  zlzszxytxx: 'Aquí se muestra el último mensaje',
  jj_1: 'Solo',
  lt: 'Chat',
  qkdltjljwfhf: 'El historial borrado no se puede recuperar',
  qjscz: 'Operar con precaución',
  qrqk: 'Confirmar borrado',
  zzqk: 'Borrando',
  ltjlyqk: 'Historial borrado',
  jl: 'Guerlain',
  zwhd: 'Sin actividades',
  xhdbt: 'Nuevo título de actividad',
  zlzsxhdjjdfzxwa: 'Texto descriptivo de actividad',
  sgjbxbptgdhdbt: 'Título promoción producto',
  zlzshdjjdfzxwa: 'Texto auxiliar de actividad',
  glytz: 'Aviso del administrador',
  fssj: 'Hora de envío',
  qdyc: 'Confirmar eliminación',
  m_1: '?',
  sjhcdbzq: 'Longitud de teléfono incorrecta',
  xy: 'Acuerdo',
  lxdh: 'Teléfono',
  lxyx: 'Email de contacto',
  bd: 'Vincular',
  bbh: 'Versión',
  qdytcm: '¿Seguro que desea salir?',
  tc: 'Salir',
  xz_1: 'Añadir nuevo',
  qxzs: 'Seleccione provincia',
  s_1: 'Ciudad',
  q_2: 'Distrito',
  zjs: 'Provincia Zhejiang',
  s_2: 'Provincia',
  ws: 'Soy',
  rzzn: 'Guía de verificación',
  ptbhgkyhysxx: 'La plataforma protege la privacidad',
  jxyyzsf: 'Solo para verificación',
  zzrz: 'Verificación de cualificación',
  sfrz: 'Verificación de identidad',
  sbzcz: 'Certificado de marca',
  yyzz: 'Licencia comercial',
  ppm: 'Nombre de marca',
  gsqc: 'Nombre legal empresa',
  hy: 'Industria',
  ly_2: 'Área',
  qywx: 'WeCom empresarial',
  ddgrzly: 'Perfil DingTalk',
  zzzm: 'Certificado laboral',
  xbhxm: 'Debe incluir nombre',
  gsmhzw: 'Empresa y cargo',
  zzzmxjgsqzthsgz: 'Debe llevar sello oficial',
  bzc: 'No compatible',
  z_2: 'Sello',
  dzz: 'Sello electrónico',
  bmzjzyz: 'Sello departamental',
  xm_1: 'Nombre',
  sfzh: 'Nº identificación',
  mysfz: 'Sin documento',
  kglybzly: 'Admin puede dejar nota',
  wcnyszlzskx: 'Declaro información real',
  dphtjt: 'Captura backend tienda',
  dpwljt: 'Captura logística',
  dpmc: 'Nombre tienda',
  dplj: 'Enlace tienda',
  yzxgflfg: 'Según normativa legal',
  qxyzsf: 'Verifique identidad primero',
  sqrz: 'Solicitar verificación',
  nyjs: 'Usted ya es',
  rztgz: 'Anunciante verificado',
  nytjrzsq: 'Solicitud enviada',
  qddsh: 'Espere revisión',
  shbjj: 'Revisión rechazada',
  rgnytgzjgsdcp: 'Si promociona su empresa',
  rgnszdgsxytgqtgsdcp: 'Si su empresa promociona otra',
  rgnsygrmytgqtgsdcp: 'Promoción personal',
  rgnstb: 'Si usa Taobao',
  tm: 'Tmall',
  jdddssj: 'Comerciantes JD u otros',
  xtgzjdpdcp: 'Promocionar productos propios',
  yppfgtjl: 'Registro comunicación marca',
  xzsqsmb: 'Descargar plantilla autorización',
  pptfsq: 'Autorización de marca',
  ht: 'Contrato',
  xjgsqzthsgz: 'Sello oficial requerido',
  sqgsqc: 'Nombre empresa autorizada',
  qxlh: 'Quitar bloqueo',
  ygz: 'Seguido',
  qrqxlhgtgz: 'Confirmar desbloqueo',
  jjxzsgtgzdtg: 'Se volverán a mostrar campañas',
  jxlh: 'Mantener bloqueo',
  qxlhcg: 'Desbloqueado correctamente',
  qrlhgtgz: 'Confirmar bloqueo',
  jbzzsgtgzdtg: 'No se mostrarán campañas',
  lh: 'Bloquear',
  blh: 'No bloquear',
  lhcg: 'Bloqueado correctamente',
  zx_1: 'Centro',
  hjbj: 'Cuánto tiempo',
  ndhyygq: 'Membresía expirada',
  ljgm: 'Comprar ahora',
  ktqyd: 'Leer antes de activar',
  hyfwxy: 'Acuerdo de membresía',
  hyqydb: 'Comparación beneficios',
  qydb: 'Comparativa',
  fhy: 'No miembro',
  yfhy: 'Membresía mensual',
  j_1: 'Solo',
  jfhy: 'Membresía trimestral',
  nfhy: 'Membresía anual',
  mrjstgsx: 'Límite diario desbloqueo',
  wx_1: 'Ilimitado',
  mrkbmsx: 'Límite diario solicitudes',
  gjrw: 'Tareas premium',
  xlrw: 'Tareas limitadas',
  rwtjsfyx: 'Prioridad algoritmo',
  yxppgzhrw: 'Prioridad tareas conversión',
  rwss: 'Buscar tareas',
  dy_2: 'Suscribirse',
  zcgjc: 'Soporta palabras clave',
  hyfl: 'Categoría industria',
  mggty: 'Experiencia sin anuncios',
  dsjzhbd: 'Vincular múltiples cuentas',
  r_2: 'Como',
  zskfzc: 'Soporte exclusivo',
  xszc: 'Soporte por horas',
  rwshyxcl: 'Revisión prioritaria',
  rw: 'Tarea',
  xsnsh: 'Revisado en horas',
  hyjfjlfb: 'Puntos dobles',
  zshz: 'Insignia exclusiva',
  rwtgtsbg: 'Mayor exposición',
  yxtj: 'Recomendación prioritaria',
  zp_1: 'Obras',
  qxtyhyfwxy: 'Acepte acuerdo primero',
  qxzygmdhyfa: 'Seleccione plan',
  wxts: 'Recordatorio',
  byebz: 'Saldo insuficiente',
  qdyqczm: '¿Ir a recargar?',
  tjxk: 'Añadir nueva tarjeta',
  yhxx: 'Información bancaria',
  m_2: 'Nombre',
  qsrm: 'Introduzca nombre',
  xs_1: 'Apellido',
  qsrxs: 'Introduzca apellido',
  kh: 'Número de tarjeta',
  qsrkh: 'Introduzca número',
  sxrq: 'Fecha expiración',
  qsrrq: 'Introduzca fecha',
  qsrsjrxm: 'Introduzca destinatario',
  qsrdz: 'Introduzca dirección',
  qxzcs: 'Seleccione ciudad',
  wsdk: 'Mastercard',
  zgyh: 'Bank of China',
  cxk: 'Tarjeta débito',
  payh: 'Ping An Bank',
  hxyh: 'Huaxia Bank',
  qdysczzyhkm: '¿Eliminar tarjeta?',
  sr_1: 'Ingresos',
  zc_2: 'Gastos',
  zd_2: 'Factura',
  wdye: 'Mi saldo',
  djje_1: 'Límite congelado',
  djmx: 'Detalle de congelación',
  ckmx: 'Ver detalles',
  djsj: 'Hora de congelación',
  djje: 'Importe congelado',
  tgmc: 'Nombre de campaña',
  txed: 'Importe de retiro',
  kydh: 'Canjeable',
  yhkh: 'Nº tarjeta bancaria',
  txxx_1: 'Información retiro',
  yhkszgj: 'País banco',
  yhmc: 'Nombre banco',
  zhcyrxm: 'Titular cuenta',
  dm: 'Código',
  tkje: 'Importe retiro',
  zt_1: 'Estado',
  shbh: 'Rechazado',
  sxf: 'Comisión',
  jx: 'Continuar',
  czcg_1: 'Recarga exitosa',
  jxcz: 'Seguir recargando',
  wc: 'Finalizar',
  czfs: 'Método recarga',
  qxzyhk: 'Seleccione tarjeta',
  dcjyesx: 'Límite por transacción',
  czje: 'Importe recarga',
  yxsrsz: 'Solo números permitidos',
  dqdfhdcszjp: 'Teclado numérico',
  qsrje: 'Introduzca importe',
  xe: 'Límite',
  dqzhtbye: 'Saldo actual monedas',
  ljcz: 'Recargar ahora',
  pfyh: 'SPD Bank',
  zsyh: 'China Merchants Bank',
  qsrczje: 'Introduzca monto',
  yhdhk: 'Transferencia bancaria',
  qxzyhszgj: 'Seleccione país banco',
  yhszgj: 'País banco',
  qtxyhmc: 'Complete banco',
  qsryhmc: 'Introduzca banco',
  yhfhdz: 'Dirección sucursal',
  qsryhfhdz: 'Introduzca dirección',
  qtxzhcyrxm: 'Complete titular',
  qsrzhcyrxm: 'Introduzca titular',
  gjyhzh: 'IBAN',
  qsrtkje: 'Introduzca retiro',
  xyxh: 'Consumirá',
  txsqytj: 'Solicitud enviada',
  hdmc: 'Nombre actividad',
  ye: 'Saldo',
  jbcttg: 'Reportar este anuncio',
  xzjbly: 'Seleccionar motivo',
  jbyy: 'Motivo reporte',
  txjbyy: 'Escribir motivo',
  jbcg: 'Reporte enviado',
  szh: 'Después de configurar',
  xthzdsxfhyqdbmbz: 'Sistema filtrará creadores',
  drly: 'Área creador',
  qg: 'Nacional',
  wctgrw: 'Completar tarea',
  fh: 'Volver',
  jxlnky: 'Ahora puedes',
  qsrwz: 'Introduzca URL',
  bjtjcg: 'Contenido enviado',
  bjytj: 'Post enviado',
  yhz: 'Colaborado',
  ygs: 'Aprobado',
  dpj: 'Pendiente evaluación',
  yjtbjz: 'Valor comisión',
  bj_1: 'Contenido',
  fkpz: 'Comprobante pago',
  kzybmlbplcz: 'Operación masiva disponible',
  qbhs: 'Todos adecuados',
  fzmdlj: 'Copiar enlace lista',
  zwkf: 'No disponible aún',
  dqmykyplczdsj: 'Sin datos para operación',
  plcz: 'Operación masiva',
  qdyzxcczm: '¿Confirmar operación?',
  dzsl: 'Número de likes',
  scsl: 'Número de favoritos',
  ysx: 'Filtrado',
  qytgzqrhz: 'Confirme con anunciante',
  qddtgztyhz: 'Espere a que el anunciante apruebe la cooperación',
  ytgzlyl: 'Chatear con anunciante',
  ddsjxx: 'Esperando mensaje',
  sjhzdlxhsrx: 'Comerciante contactará',
  sdcpcl: 'Material recibido',
  cp: 'Producto',
  ayqfbjhsp: 'Publicar según requisitos',
  fsjbjlj: 'Enviar enlace',
  lqgf: 'Recibir pago',
  gzgzh: 'Seguir cuenta oficial',
  jsjstx: 'Recibir avisos',
  spxq: 'Detalles producto',
  kytbs: 'Monedas disponibles',
  ljdh: 'Canjear ahora',
  xzdhsl: 'Seleccionar cantidad',
  dh_1: 'Canjear',
  qxzdhsl: 'Seleccione cantidad',
  dhcg: 'Canje exitoso',
  sy: 'Restante',
  dhjl: 'Historial canje',
  xx_1: 'Xiao Xiao',
  bggcdl: 'Bai acaba de ganar',
  cdl: 'Ganado',
  jfcjgz: 'Reglas sorteo puntos',
  jfdhsp: 'Productos por puntos',
  qdh: 'Ir a canjear',
  zwsp: 'Sin productos',
  xxcy: 'Gracias por participar',
  dhsj: 'Hora canje',
  ddbh: 'Nº pedido',
  dhsl: 'Cantidad canje',
  sf: 'Pago real',
  zwdhsj: 'Sin datos canje',
  cj_1: 'Sorteo',
  zjsj: 'Hora premio',
  tbjz: 'Valor monedas',
  zwcjsj: 'Sin datos sorteo',
  gxzj: 'Felicidades',
  hyhwzj: 'No ganó',
  yzlycm: '¿Intentar de nuevo?',
  kxsx: 'Aceptar felizmente',
  yy_zh: 'ZH',
  yy_en: 'EN',
  yy_sp: 'ES',
  sys_msg_type_101: 'Verificación del anunciante aprobada',
  sys_msg_type_102: 'Verificación del anunciante rechazada',
  sys_msg_type_103: 'Revisión de liquidación de monedas',
  sys_msg_type_104: 'Pendiente de revisión',
  sys_msg_type_105: 'Tarjeta de perfil aprobada',
  sys_msg_type_106: 'Tarjeta de perfil rechazada',
  sys_msg_type_107: 'Anuncio aprobado',
  sys_msg_type_108: 'Anuncio rechazado',
  sys_msg_type_109: 'Retiro aprobado',
  sys_msg_type_110: 'Retiro rechazado',
  sys_msg_type_111: 'Retiro en revisión',
  sys_msg_type_201: 'El creador se inscribió',
  sys_msg_type_202: 'Marcar como adecuado',
  sys_msg_type_203: 'Inscripción rechazada',
  sys_msg_type_204: 'Cupo completo',
  sys_msg_type_301: 'Aviso de nuevo seguidor / seguimiento',
  sys_msg_type_302: 'Anuncio guardado en favoritos',
  sys_msg_type_401: 'Aviso del sistema',
  sys_msg_type_402: 'Aviso de campaña',
  sys_msg_type_403: 'Aviso de advertencia',
  sys_msg_reason_none: 'Ninguna',
  sys_msg_unknown_user: 'Usuario desconocido',
  sys_msg_unknown_announcement: 'Anuncio desconocido',
  sys_msg_content_101:
    '¡Enhorabuena! Su solicitud de verificación como anunciante ha sido aprobada.',
  sys_msg_content_102_plain:
    'Lo sentimos, su solicitud de verificación como anunciante no ha sido aprobada.',
  sys_msg_content_102_reason:
    'Lo sentimos, su solicitud de verificación como anunciante no ha sido aprobada. Motivo: {reason}',
  sys_msg_content_104_reviewing:
    'Su anuncio «{name}» está en revisión.',
  sys_msg_content_104_pending:
    'Su anuncio «{name}» está pendiente de revisión.',
  sys_msg_content_105:
    'Su tarjeta de perfil de {platform} ha sido aprobada.',
  sys_msg_content_106:
    'Su tarjeta de perfil de {platform} no ha sido aprobada. Motivo: {reason}',
  sys_msg_content_107: 'Su anuncio «{name}» ha sido aprobado.',
  sys_msg_content_108_no_reason:
    'Su anuncio «{name}» no ha sido aprobado.',
  sys_msg_content_108_with_reason:
    'Su anuncio «{name}» no ha sido aprobado. Motivo: {reason}',
  sys_msg_content_109:
    'Su solicitud de retiro (importe: {amount} EUR) ha sido aprobada; debería llegar en un plazo de 3 días laborables.',
  sys_msg_content_110:
    'Su solicitud de retiro (importe: {amount} EUR) no ha sido aprobada. Motivo: {reason}',
  sys_msg_content_111:
    'Su solicitud de retiro (importe: {amount} EUR) está en revisión. Espere, por favor.',
  sys_msg_content_201:
    'El creador {nickname} se inscribió en su anuncio: {title}',
  sys_msg_content_204:
    'Las plazas adecuadas del anuncio «{name}» están completas. Gracias por inscribirse.',
  sys_msg_content_301: 'El usuario {operatorNickname} le ha seguido.',
  sys_msg_content_302:
    'El usuario {operatorNickname} ha guardado su anuncio «{activityName}» en favoritos.',
  'advertiser.announcement_register_business_card_required':
    'No se ha creado tarjeta de visita',
  'advertiser.announcement_register_business_card_pending':
    'Tarjeta de visita en revisión',
  'advertiser.announcement_register_business_card_rejected':
    'Tarjeta de visita no aprobada',
  'advertiser.announcement_register_business_card_fetch_failed':
    'Error al obtener la tarjeta de visita',
  'global.success': 'Correcto',
  'global.bad_request': 'Parámetros de solicitud incorrectos',
  'global.unauthorized': 'Cuenta no iniciada',
  'global.forbidden': 'Sin permiso para esta acción',
  'global.not_found': 'Solicitud no encontrada',
  'global.method_not_allowed': 'Método HTTP incorrecto',
  'global.locked': 'Error en la solicitud, inténtelo más tarde',
  'global.too_many_requests': 'Demasiadas solicitudes, inténtelo más tarde',
  'global.internal_server_error': 'Error del sistema',
  'global.not_implemented': 'Función no implementada o no disponible',
  'global.error_configuration': 'Configuración incorrecta',
  'global.repeated_requests': 'Solicitud duplicada, inténtelo más tarde',
  'global.demo_deny': 'Modo demo: operaciones de escritura deshabilitadas',
  'global.unknown': 'Error desconocido',
  flow: {
    advertiser_draft_approved:
      'Borrador aprobado. Publique la nota.',
    advertiser_draft_rejected:
      'Borrador rechazado. Revíselo y vuelva a enviarlo.',
    advertiser_evaluation:
      'El anunciante ha terminado la evaluación.',
    advertiser_payment:
      'El anunciante ha completado el pago. Gracias por colaborar.',
    advertiser_suitable:
      'El anunciante considera que encaja. Suba el borrador.',
    advertiser_unsuitable:
      'El anunciante considera que no encaja. Gracias por participar.',
    influencer_evaluation:
      'El creador ha terminado la evaluación. Gracias por colaborar.',
    influencer_submit_note:
      'El creador ha enviado la nota. Revise y confirme.',
    influencer_upload_draft:
      'El creador ha subido un borrador. Revíselo pronto.',
  },
};
